var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":require("@/assets/images/icon/bar-chart-2.png"),"width":"30px"}})}
var staticRenderFns = []

export { render, staticRenderFns }